<template>
    <div ref="searchcontainer">
        <div class="w-full md:w-6/12 md:pr-sm relative mb-md z-10">
            <label for="search" class="font-semibold mb-xxs inline-block">Zoeken</label>
            <div class="relative">
                <input id="search" autofocus class="form__input form__input--filled-dark" v-model="searchInput" type="text" :placeholder="placeholder" />
                <div class="absolute right-sm top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">
                    <i class="fa-regular fa-search"></i>
                </div>
            </div>
        </div>
        <productoverview ref="overview" :search="searchInput"></productoverview>
        <slot></slot>
    </div>
</template>

<script>
import productoverview from './overview';

export default {
    name: 'productsearch',
    props: ['placeholder'],

    components: { productoverview },

    data() {
        return {
            searchInput: '',
        };
    },

    mounted() {
        const currentLangElements = document.querySelectorAll(`#searchgrid div[data-lang=${document.documentElement.lang}]`);
    currentLangElements.forEach((e) => e.classList.add('order-first'));
    },
};
</script>
